"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProvidersModule = void 0;
const router_1 = require("client/components/router");
const providers_import_1 = require("./modules/providers-import");
const providers_import_map_header_1 = require("./modules/providers-import-map-header");
const providers_import_preview_1 = require("./modules/providers-import-preview");
const providers_import_select_header_1 = require("./modules/providers-import-select-header");
const providers_list_1 = require("./modules/providers-list");
class ProvidersModule extends router_1.Router {
    constructor(props) {
        super(props);
        this.addRoute("import", /^\/providers\/import?$/, providers_import_1.ProvidersImport);
        this.addRoute("import/map", /^\/providers\/import\/map?$/, providers_import_map_header_1.ProvidersImportMapHeader);
        this.addRoute("import/select", /^\/providers\/import\/select?$/, providers_import_select_header_1.ProvidersImportSelectHeader);
        this.addRoute("import/preview", /^\/providers\/import\/preview?$/, providers_import_preview_1.ProvidersImportPreview);
        this.addRoute("list", /^\/providers\/?$/, providers_list_1.ProvidersList);
        this.addRoute("detail", /^\/providers\/(\d+)/, providers_list_1.ProvidersList);
    }
}
exports.ProvidersModule = ProvidersModule;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/providers/provider.tsx
// module id = 3838
// module chunks = 0